import React from "react";

import { useSelector, useDispatch } from "types/store";

import ChatGPTContainer from "components/ChatGPT/ChatGPT";
import ChatGPTHeader from "components/Next/ChatGPTHeader";
import KPIDashboard from "components/ChatGPT/Dashboard/KPIDashboard";

import * as nextReducer from "containers/Next/NextReducer";

import styles from "./style.module.css";

const ChatGPTWrapper = ({ id, blueprintId, previousReportData } = {}) => {
  const activeTab = useSelector((state) => nextReducer.getActiveTab(state, id));

  return (
    <div className={styles.nextHolderSection}>
      <div className={styles.mOuter}>
        <div className={styles.chatGPTHolder}>
          {activeTab === "KPI DASHBOARD" ? (
            <KPIDashboard nextId={id} blueprintId={blueprintId} />
          ) : (
            <ChatGPTContainer nextId={id} blueprintId={blueprintId} />
          )}
        </div>
        <div className={styles.next}>
          {window?.looker_API !== undefined ? (
            <div />
          ) : (
            <ChatGPTHeader id={id} previousReportData={previousReportData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatGPTWrapper;
